export const loadNextStepModule = {
    
    getNextStep(step, product) {
        let stepData = {
            currentStep: step,
            minProduct: product
        }
        this.emit("fetch", stepData)
    },

    loadData() {
        this.emit("load")
    },

    completeLoading() {
        this.emit("loadComplete")
    },

    createContent(data) {
        this.emit("create", data)
    },

    showContent() {
        this.emit("show")
    },


    emitError(message = "") {
        console.error("Too less arguments to fulfill fetch request. Please ask the system administrator for help, if this happens more than once.")
        console.error(message);
        this.emit("error", message);
    },

    emitUrlError(message = "") {
        console.error("Too less arguments to fulfill fetch request. Please ask the system administrator for help, if this happens more than once.")
        console.error(message);
        this.emit("urlError", message);
    },


    events: {},
    /**
     * Löst ein Ereignis aus. Dieser Funktion dürfen beliebig viele
     * params übergeben werden, diese werden 1:1 an die Event-Listener
     * durchgereicht.
     *
     * @param {string} eventName
     * @param {*=} params
     */
    emit(eventName, param = null) {
        if (eventName in this.events) {
            for (const f of this.events[eventName]) {
                f(param)
            }
        }

    },
    /**
     * Registriert einen Event-Listener für das Event eventName.
     *
     * @param {string} eventName
     * @param {Function} cb
     */
    on(eventName, cb) {
        // Hier ist die Klammersetzung ganz wichtig!
        if (!(eventName in this.events)) {
            this.events[eventName] = []
        }
        this.events[eventName].push(cb)
        
    }
}


loadNextStepModule.on("fetch", (stepData) => {
    getNextStep(stepData);
})




function getNextStep(stepData) {
    loadNextStepModule.loadData()
    jQuery.ajax({
        url: cloudmanufaktur.ajaxurl,
        type: 'post',
        data: {
            action: "evaluateNextStep",
            currentStep: stepData.currentStep,
            minProduct: stepData.minProduct
        },
        error: (data) => {
            console.error(data)
            if (data.status === 404) {
                loadNextStepModule.emitError("Diesen Schritt gibt es nicht.");
            }
            else {
                loadNextStepModule.emitError("Es gab einen Fehler im Backend.");
            }
        },
        success: function (data) {
            loadNextStepModule.createContent(data)
            loadNextStepModule.completeLoading()
        }
    })

}

